export enum CoreStatus {
  WAITING_FOR_INTAKE = 'Waiting for Intake',
  NOT_TRIGGERED = 'Not-Triggered',
  NOT_READY = 'Not Ready',
  PRE_DEPOSIT = 'Pre-Deposit',
  POST_DEPOSIT = 'Post-Deposit',
  DRAFT_CAS = 'Draft CAS',
  PATHWAY_REVIEW = 'Pathway Review',
  READY_FOR_CAS = 'Ready for CAS',
  CAS_ISSUED = 'CAS Issued',
  VISA_ISSUED = 'Visa Issued',
  VISA_REFUSED = 'Visa Refused',
  DEFERRED = 'Deferred',
  CLOSED_LOST = 'Closed Lost',
  CLOSED_OTHER = 'Closed Other',
  AWAITING_INFO = 'Awaiting Info',
  COMPLIANCE_CHECK = 'Compliance Check'
}

export enum CoreStatusExtended {
  WAITING_FOR_INTAKE = 'Waiting for Intake',
  NOT_TRIGGERED = 'Not-Triggered',
  NOT_READY = 'Not Ready',
  PRE_DEPOSIT = 'Pre-Deposit',
  POST_DEPOSIT = 'Post-Deposit',
  DRAFT_CAS = 'Draft CAS',
  PATHWAY_REVIEW = 'Pathway Review',
  READY_FOR_CAS = 'Ready for CAS',
  CAS_ISSUED = 'CAS Issued',
  VISA_ISSUED = 'Visa Issued',
  VISA_REFUSED = 'Visa Refused',
  DEFERRED = 'Deferred',
  CLOSED_LOST = 'Closed Lost',
  CLOSED_OTHER = 'Closed Other',
  AWAITING_INFO = 'Awaiting Info',
  INTERVIEW = 'Interview',
  COMPLIANCE_CHECK = 'Compliance Check'
}

export enum IntakeStatus {
  FUTURE = 'Future',
  ACTIVE = 'Active',
  CLOSED = 'Closed',
  ARCHIVED = 'Archived'
}

export enum NotReadyReason {
  NOT_PROCESSED = 'Not Processed',
  UNKNOWN_INTAKE = 'Unknown Intake',
  INACTIVE_INTAKE = 'Inactive Intake',
  ALL_COURSES_DECLINED = 'All Courses Declined',
  INVALID_EMAIL = 'Invalid Email',
  BOUNCED_EMAIL = 'Bounced Email',
  DUPLICATE_EMAIL = 'Duplicate Email'
}

export enum VisaStatus {
  NONE = 'None',
  CAS_NOT_RECEIVED = 'CAS not received',
  CAS_RECEIVED = 'CAS received',
  VISA_APPLIED = 'Visa applied',
  AWAITING_VISA_RESPONSE = 'Awaiting visa response',
  UKVI_REQUEST_MORE_INFO = 'UKVI request more info',
  VISA_RECEIVED = 'Visa received',
  VISA_REFUSAL = 'Visa refusal',
  INTENDS_TO_DEFER = 'Intends to defer',
  INTENDS_TO_WITHDRAW = 'Intends to withdraw'
}

export enum OfferStatus {
  FOR_REVIEW = 'For review',
  DECLINED = 'Declined',
  REMOVED = 'Removed',
  NOT_RESOLVED = 'Not resolved',
  UNCONDITIONAL = 'Unconditional',
  CONDITIONAL = 'Conditional'
}

export enum CourseLevelOfferStatus {
  DECLINED = 'Declined',
  REMOVED = 'Removed',
  UNCONDITIONAL = 'Unconditional',
  CONDITIONAL = 'Conditional'
}

export enum PersonalInfoPages {
  STEP1 = 'pi-step1',
  STEP2 = 'pi-step2',
  STEP3 = 'pi-step3',
  STEP4 = 'pi-step4',
  STEP5 = 'pi-step5',
  STEP5_1 = 'pi-step5_1',
  STEP6 = 'pi-step6',
  STEP7 = 'pi-step7',
  STEP8 = 'pi-step8',
  STEP9 = 'pi-step9',
  STEP10 = 'pi-step10'
}

export enum HistoryPages {
  STEP1 = 'h-step1',
  STEP2 = 'h-step2',
  STEP3 = 'h-step3'
}

export enum ConsentsPages {
  STEP1 = 'c-step1',
  STEP2 = 'c-step2',
  STEP3 = 'c-step3',
  STEP4 = 'c-step4'
}

export enum InterviewPages {
  STEP1 = 'pc-step1',
  STEP2 = 'pc-step2',
  STEP3 = 'pc-step3',
  STEP4 = 'pc-step4'
}

export enum VisaPrepPages {
  STEP1 = 'v-step1',
  STEP1_2 = 'v-step1-2',
  STEP2_1 = 'v-step2-1',
  STEP2_2 = 'v-step2-2',
  STEP2_3 = 'v-step2-3',
  STEP2_4 = 'v-step2-4',
  STEP2_5 = 'v-step2-5',
  STEP2_6 = 'v-step2-6',
  STEP2_7 = 'v-step2-7',
  STEP2_8 = 'v-step2-8',
  STEP3_1 = 'v-step3-1',
  STEP3_2 = 'v-step3-2',
  STEP3_3 = 'v-step3-3',
  STEP3_4 = 'v-step3-4',
  STEP3_5 = 'v-step3-5',
  STEP4 = 'v-step4',
  STEP5 = 'v-step5',
  STEP6 = 'v-step6',
  STEP7_1 = 'v-step7-1',
  STEP7_2 = 'v-step7-2',
  STEP7_3 = 'v-step7-3',
  STEP8 = 'v-step8'
}
